import { render, staticRenderFns } from "./panelExtensionManage.vue?vue&type=template&id=6528091e&"
import script from "./panelExtensionManage.vue?vue&type=script&lang=js&"
export * from "./panelExtensionManage.vue?vue&type=script&lang=js&"
import style0 from "./panelExtensionManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports